function PriceFormulation() {
  return (
    <>
      <div>this is price formulation page</div>
    </>
  );
}

export default PriceFormulation;
